import React, { useState } from 'react'
import { Dialog } from 'components/ds'

import { CancelSubscriptionModalStepOne } from './CancelSubscriptionModalStepOne'
import { CancelSubscriptionModalStepTwo } from './CancelSubscriptionModalStepTwo'
import { CancelSubscriptionModalStepThree } from './CancelSubscriptionModalStepThree'

type CancelSubscriptionModalProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** Replaces step one's legacy `/settings/billing/plans` link when given; null leaves the line out */
  changePlanLink?: React.ReactNode
}

const CurrentStep = ({
  currentStep,
  onNext,
  changePlanLink,
}: {
  currentStep: number
  onNext: () => void
  changePlanLink?: React.ReactNode
}) => {
  switch (currentStep) {
    case 1:
      return (
        <CancelSubscriptionModalStepOne
          onNext={onNext}
          changePlanLink={changePlanLink}
        />
      )
    case 2:
      return <CancelSubscriptionModalStepTwo onNext={onNext} />
    case 3:
      return <CancelSubscriptionModalStepThree />
  }
}

/** The in-app cancellation flow: warning, reasons and confirmation steps in one dialog. */
export const CancelSubscriptionModal = ({
  open,
  onOpenChange,
  changePlanLink,
}: CancelSubscriptionModalProps) => {
  const [currentStep, setCurrentStep] = useState(1)

  function handleOpenChange(open: boolean) {
    onOpenChange(open)
    setCurrentStep(1)
  }

  return (
    <Dialog.Root open={open} onOpenChange={handleOpenChange}>
      <Dialog.Content maxWidth="600px">
        <CurrentStep
          currentStep={currentStep}
          onNext={() => setCurrentStep(currentStep + 1)}
          changePlanLink={changePlanLink}
        />
      </Dialog.Content>
    </Dialog.Root>
  )
}
